import React from 'react';

import { TFunction } from 'react-i18next';

import { Id } from 'types/Id';

type Params = {
  id: Id;
  key: Id;
  name: string;
  category?: [string | null, string];
  owner?: string;
};
const assetResultComponent = ({ name, category, owner }: Params, t: TFunction) => {
  const [categoryTranslationKey, categoryFallback] = category || [null, ''];
  const categoryTranslated = categoryTranslationKey ? t([categoryTranslationKey, categoryFallback]) : categoryFallback;
  const content = [name];
  if (categoryTranslated) content.push(`(${categoryTranslated})`);
  return (
    <span>
      {content.join(' ')}
      {owner && <span style={{ opacity: 0.7, marginLeft: 8 }}>- {owner}</span>}
    </span>
  );
};

export default assetResultComponent;
